import BaseProxy from './base-proxy';

/**
 * Class ProductCategoryProxy
 */
class ProductCategoryProxy extends BaseProxy {
  /**
   * Constructor.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/e-invoice-api/api', parameters);
  }

  /**
   * @param {Object} params - { page, page_size }
   * @returns {Promise}
   */
  list(params = {}) {
    this.setParameters(params);
    return this.submit('get', `${this.endpoint}/product-categories/`);
  }

  /**
   * @param {number} id
   * @returns {Promise}
   */
  detail(id) {
    return this.submit('get', `${this.endpoint}/product-categories/${id}/`);
  }

  /**
   * @param {Object} data - { name, description }
   * @returns {Promise}
   */
  create(data) {
    return this.submit('post', `${this.endpoint}/product-categories/`, data);
  }

  /**
   * @param {number} id
   * @param {Object} data - { name, description }
   * @returns {Promise}
   */
  update(id, data) {
    return this.submit('put', `${this.endpoint}/product-categories/${id}/`, data);
  }

  /**
   * @param {number} id
   * @returns {Promise}
   */
  delete(id) {
    return this.submit('delete', `${this.endpoint}/product-categories/${id}/`);
  }
}

export default ProductCategoryProxy;



// WEBPACK FOOTER //
// ./src/store/proxies/product-category-proxy.js